interface Plan {
  name: string;
  price?: string;
  period?: string;
  highlighted?: boolean;
  features?: string[];
  ctaText?: string;
  ctaLink?: string;
}

export function PricingTableBlock({ props }: { props: { title?: string; plans?: Plan[] } }) {
  const plans = props.plans ?? [];
  if (plans.length === 0) return null;

  return (
    <div className="py-8 px-4">
      {props.title && (
        <h2 className="text-2xl sm:text-3xl font-bold text-zinc-900 text-center mb-8">{props.title}</h2>
      )}
      <div className={`grid grid-cols-1 gap-6 ${plans.length > 1 ? 'sm:grid-cols-2 lg:grid-cols-3' : 'max-w-sm mx-auto'}`}>
        {plans.map((plan, i) => (
          <div
            key={i}
            className={`flex flex-col rounded-xl border p-6 shadow-sm ${
              plan.highlighted
                ? 'border-[var(--color-primary,#4F46E5)] bg-[var(--color-primary,#4F46E5)] text-white shadow-lg scale-[1.02]'
                : 'border-zinc-200 bg-white text-zinc-800'
            }`}
          >
            <div className="mb-4">
              <h3 className={`font-bold text-lg ${plan.highlighted ? 'text-white' : 'text-zinc-900'}`}>{plan.name}</h3>
              {plan.price && (
                <div className="mt-2 flex items-baseline gap-1">
                  <span className={`text-3xl font-extrabold ${plan.highlighted ? 'text-white' : 'text-zinc-900'}`}>{plan.price}</span>
                  {plan.period && (
                    <span className={`text-sm ${plan.highlighted ? 'text-white/70' : 'text-zinc-500'}`}>/{plan.period}</span>
                  )}
                </div>
              )}
            </div>
            {plan.features && plan.features.length > 0 && (
              <ul className="flex flex-col gap-2 mb-6 flex-1">
                {plan.features.map((f, j) => (
                  <li key={j} className={`flex items-start gap-2 text-sm ${plan.highlighted ? 'text-white/90' : 'text-zinc-600'}`}>
                    <svg className={`w-4 h-4 flex-shrink-0 mt-0.5 ${plan.highlighted ? 'text-white' : 'text-[var(--color-primary,#4F46E5)]'}`} fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                    {f}
                  </li>
                ))}
              </ul>
            )}
            {plan.ctaText && (
              <a
                href={plan.ctaLink ?? '#'}
                className={`mt-auto block text-center px-4 py-2.5 rounded-lg text-sm font-semibold transition-colors ${
                  plan.highlighted
                    ? 'bg-white text-[var(--color-primary,#4F46E5)] hover:bg-zinc-50'
                    : 'bg-[var(--color-primary,#4F46E5)] text-white hover:opacity-90'
                }`}
              >
                {plan.ctaText}
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
